import LoginBanner from 'components/shared/LoginBanner'
import React from 'react'

const AccountLocked = () => {
  return (
    <div className="grid grid-cols-1 bg-[#F2F2F2]  md:grid-cols-2">
      <div className="flex flex-wrap flex-col justify-center px-1  h-svh md:px-32">
        <div className="text-3xl font-bold">
          Account Locked
        </div>
        <div className="mt-3 text-sm font-normal text-lightGrey">
          Your account has been locked due to multiple failed<br />attempts. It will unlocked in
        </div>
        <div className="mt-9  border-2 border-[#CD2B2B]  flex justify-center items-center w-full bg-white py-3 font-semibold text-sm text-[#CD2B2B] rounded-md ">
          23h 59m 59s
        </div>
        <div className="mt-3 flex  text-xs font-semibold gap-1">
          <div className="text-lightGrey">Need Help?</div>
          <a className="text-secondary" href="/resetpassword">
            Reset Password
          </a>
        </div>
      </div>
      <LoginBanner />
    </div>
  )
}

export default AccountLocked